import React from "react";
import { AccountLock as AccountLockIcon } from "@actinc/dls/icons";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * Generic "you don't have permission" page for permission-gated routes.
 * Render this instead of returning null when a user reaches a screen they
 * aren't authorized for, so the content area shows a clear message rather
 * than appearing blank. Reusable across flows via the title/message props.
 */
const NoAccess = ({
  actionLabel = "Go Back",
  message = "You do not have permission to view this page.",
  onAction,
  title = "Access Denied",
}) => {
  const navigate = useNavigate();
  const handleAction = onAction || (() => navigate(-1));

  return (
    <Box
      aria-label="Access Denied"
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 2,
        justifyContent: "center",
        padding: 4,
        textAlign: "center",
        width: "100%",
      }}
    >
      <AccountLockIcon color="action" sx={{ fontSize: 64 }} />
      <Typography variant="h5">{title}</Typography>
      <Typography color="text.secondary" variant="body1">
        {message}
      </Typography>
      {actionLabel && (
        <Button onClick={handleAction} variant="outlined">
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export { NoAccess };
